import { Box } from "@mui/material";
import React from "react";

export function PageContainer(props: React.PropsWithChildren<unknown>) {
  return (
    <Box
      id="content"
      component="section"
      aria-label="CRM Content"
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: { xs: "1rem 1rem 2rem", lg: "1rem 2rem 3rem" },
        width: "100%",
        maxHeight: "100vh",
        maxWidth: "2400px",
        overflowX: "auto",
        overflowY: "auto",
      }}
    >
      {props.children}
    </Box>
  );
}
